
import '../../styles/mix.less';
import GoBack from "../units/topbar.vue";
import goods from '../../models/goods/goods'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Search from 'vux/src/components/search/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Rater from 'vux/src/components/rater/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


const qualityList = [
{name: '全新', start: '100', end: null},
{name: 'S+', start: '97', end: '100'},
{name: 'S级', start: '94', end: '97'},
{name: 'A+', start: '90', end: '94'},
{name: 'A级', start: '86', end: '90'},
{name: 'B+', start: '82', end: '86'},
{name: 'B级', start: '78', end: '82'},
{name: 'B级以下', start: null, end: '78'}
];
export default {
beforeRouteEnter(to, from, next) {
next(vm => {
vm.load(from.name);
})
},
directives: {
TransferDom
},
components: {
XInput,
Tab,
TabItem,
XButton,
Search,
XHeader,
LoadMore,
Flexbox,
FlexboxItem,
Scroller,
Group,
Cell,
Radio,
Popup,
Rater,
goback: GoBack,
},
data() {
return {
goodscontentHeight: 300,
isLoadingList: false,
qualityList: qualityList,
brandList: null,
show: false,
gobackpath: '',
selectBrand: [null, null],
selectBrandName: '品牌',
selectQuality: null,
selectQualityName: '成色',
brandShow: false,
qualityShow: false,

goodsList: [],
totalPage: 0,
listQuery: {
qualityStart: null,
qualityEnd: null,
brandId: null,
query: null,
productSku: null,
page: 1,
rows: 20,
filterDate: 3
},
scrollerTop: 0
}
},
watch: {
selectBrand() {
this.listQuery.page = 1;
this.goodsList = [];
this.getGoodsList();
this.show = false;
},
selectQuality() {
this.listQuery.page = 1;
this.goodsList = [];
this.getGoodsList();
this.show = false;
}
},
mounted() {
const _this = this;
this.goodscontentHeight = document.documentElement.clientHeight - 110;
this.getGoodsList();
this.getBrand();


this.$refs.goodscontent.addEventListener('scroll', function (e) {
_this.onScroll()
}, false)

},
activated() {
let scrollTop = sessionStorage.getItem('scrollTop');

this.$refs.goodscontent.scrollTop = scrollTop
},
methods: {
checkSelect(key) {
if (key == this.selectQuality) {
return 'border-color: #896A49;color:#896A49';
}
return null;
},
checkSelectBrand(brandKey, key) {
if (brandKey == this.selectBrand[0] && key == this.selectBrand[1]) {
return 'border-color: #896A49;color:#896A49';
}
return null;
},
chooseBrand(brandKey, key, item) {
this.selectBrand = [brandKey, key];
this.selectBrandName = item.brandName || item.brandNameEn;
this.listQuery.brandId = item.brandId;
},
chooseQuality(key) {
const quality = this.qualityList[key];
this.selectQuality = key;
this.selectQualityName = quality.name;
this.listQuery.qualityStart = quality.start;
this.listQuery.qualityEnd = quality.end;

},
clearBrand() {
this.selectBrand = [null, null];
this.selectBrandName = "品牌";
this.listQuery.brandId = null;
},
clearQuality() {
this.selectQuality = null;
this.selectQualityName = "成色";
this.listQuery.qualityStart = null;
this.listQuery.qualityEnd = null;
},
showBox(item) {
this.show = true;
if (item == 'brand') {
this.brandShow = true;
this.qualityShow = false;
} else if (item == 'quality') {
this.qualityShow = true;
this.brandShow = false;
}
},
searchList(value) {
this.listQuery.page = 1;
this.listQuery.query = value;
this.goodsList = [];
this.getGoodsList();
},
getGoodsList() {
this.isLoadingList = true;
if (this.listQuery.query != null && /^[5-9][0-9]{5}/.test(parseInt(this.listQuery.query))) {
this.listQuery.productSku = this.listQuery.query
this.listQuery.query = null
} else {
this.listQuery.productSku = null;
}
goods.getList(this.listQuery).then(r => {
let goodsList = r.data.data.resultList;
for (let i in goodsList) {
if (goodsList[i].imagePath) {
goodsList[i].imagePath = goodsList[i].imagePath.replace('h_{height},w_{width}', "h_600,w_600")
}
}
this.goodsList = this.goodsList.concat(goodsList);
this.totalPage = Math.ceil(r.data.data.total / r.data.data.rows);
this.isLoadingList = false;
}).catch(() => {
this.isLoadingList = false;
})
},

getBrand() {
goods.getBrand().then(r => {
this.brandList = r.data.data;
}).catch(() => {
})
},
onScroll() {
if ((this.$refs.goodscontent.scrollTop + this.goodscontentHeight + 100 > this.$refs.goodsContentList.offsetHeight) && !this.isLoadingList) {
if (this.listQuery.page + 1 > this.totalPage) {
return
}
this.listQuery.page++;
this.getGoodsList()
}
},

load(path) {
if (path) {
this.gobackpath = path;
} else {
this.gobackpath = 'listPage';
}
},
detailpath(sku) {
let scrollTop = this.$refs.goodscontent.scrollTop;
sessionStorage.setItem('scrollTop', scrollTop);
this.$router.push({name: 'detail', query: {sku: sku}})
}
}
}



// WEBPACK FOOTER //
// ./src/components/homepage/goodsList.vue